<script lang="ts" setup>
import CardComponent from '@/components/CardComponent.vue'
import type { TodaysCheck } from '@/interfaces/TodaysCheck'
import { useChecksStore } from '@/stores/checksStore'
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { CheckOfflineService } from '@/services/CheckOfflineService'


const checksStore = useChecksStore()
const checkProgressService = CheckOfflineService()
const { checks } = storeToRefs(checksStore)
const props = defineProps<{
  type: string
}>()
const filteredChecks = ref([] as TodaysCheck[])
const onIssueReportSent = (check: TodaysCheck) => {
  return;
}

const filterChecks = async() => {
  if (checks.value === undefined) return [] as TodaysCheck[];
  let local: TodaysCheck[] = [];
  for (const check of checks.value) {
    if (check.category == props.type) {
      if (check.canBeFinishedMultipleTimes) {
        local.push(check)
      } else {
        if (!check.isCompleted) {
          const isCheckInProgress = await checkProgressService.isCheckInProgress(check.id);
          if (!isCheckInProgress) local.push(check)
        }
      }
    }
  }
  if (local.length > 0) {
    //  ORDER BY time, THEN ORDER BY order
    filteredChecks.value = local.sort((a: TodaysCheck, b: TodaysCheck) => {
      const aTime = a?.nextDate ? new Date(a.nextDate).getTime() : Infinity;
      const bTime = b?.nextDate ? new Date(b.nextDate).getTime() : Infinity;

      return aTime - bTime || a.order - b.order;
    });
  }
}

filterChecks()


watch(() => checks.value, async () => {
  await filterChecks()
})

</script>

<template>
  <div v-if="filteredChecks.length > 0">
    <h1>{{props.type}}</h1>
    <div style="display: flex; flex-wrap: wrap; width: 100%; flex-direction: row; gap:1%;">
      <div v-for="check in filteredChecks" :key="check.id" class="card-container">
        <CardComponent :check="check" @onIssueReportSent="onIssueReportSent" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-container{
  width: 100%;
}

@media (min-width: 1024px) {
  .card-container {
    width: 49%;
    min-width: 49%;
    max-width: 49%;
  }
}
@media (min-width: 1600px) {
  .card-container {
    width: 32%;
    min-width: 32%;
    max-width: 32%;
  }
}
</style>
